/*
  Brochiva : le fil d Ariane de la fiche produit reprend le chemin reellement suivi.

  Le rendu serveur affiche l univers de la broche, « Accueil / Broche oiseau / produit ».
  Si le visiteur arrive d une collection ou d une recherche, ce niveau du milieu devient
  la liste qu il vient de quitter, filtres et tri compris, pour qu un clic l y ramene.

  Rien ne change dans les adresses des produits ni dans les donnees structurees, qui
  restent celles de l univers. Le script ne fait que memoriser, au clic sur une carte,
  la liste d ou l on part, puis la reprendre sur la fiche si l on vient bien de la.
*/
(() => {
  if (window.__bvAriane) return;
  window.__bvAriane = true;

  const CLE = 'bvAriane';
  const lire = () => {
    try {
      return JSON.parse(sessionStorage.getItem(CLE) || 'null');
    } catch (e) {
      return null;
    }
  };
  const ecrire = (v) => {
    try {
      sessionStorage.setItem(CLE, JSON.stringify(v));
    } catch (e) {}
  };

  /* Le type de page est passe par l attribut data-page de la balise script. */
  const type = (document.currentScript && document.currentScript.dataset.page) || '';

  /* Collection ou recherche : on note la liste au moment ou l on ouvre un produit.
     L adresse est lue au clic, et non au chargement, parce que les filtres et la
     pagination la reecrivent sans recharger la page. */
  if (type === 'collection' || type === 'search') {
    document.addEventListener(
      'click',
      (e) => {
        const a = e.target.closest && e.target.closest('a[href*="/products/"]');
        if (!a || a.closest('header, footer, cart-drawer, dialog')) return;
        let titre = 'Recherche';
        if (type === 'collection') {
          const h1 = document.querySelector('main h1');
          titre = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
        }
        if (!titre) return;
        ecrire({ chemin: location.pathname, url: location.pathname + location.search, titre });
      },
      true
    );
    return;
  }

  if (type !== 'product') return;

  const origine = lire();
  if (!origine || !document.referrer) return;
  let precedente;
  try {
    precedente = new URL(document.referrer);
  } catch (e) {
    return;
  }
  /* On ne reprend la liste que si l on vient vraiment de la quitter. */
  if (precedente.origin !== location.origin || precedente.pathname !== origine.chemin) return;

  const nav = document.querySelector('[data-bv-ariane] ol');
  if (!nav) return;
  let milieu = nav.querySelector('[data-bv-ariane-milieu]');
  if (!milieu) {
    milieu = document.createElement('li');
    milieu.setAttribute('data-bv-ariane-milieu', '');
    milieu.appendChild(document.createElement('a'));
    nav.insertBefore(milieu, nav.lastElementChild);
  }
  const lien = milieu.querySelector('a');
  lien.textContent = origine.titre;
  lien.setAttribute('href', origine.url);
})();
